import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	value: [],
	id: null,
};

export const cartSlice = createSlice({
	name: "cart",
	initialState,
	reducers: {
		add_to_cart: (state, action) => {
			const existingcartItem = state.value.find(
				(cartItem) => cartItem.id === action.payload.id
			);
			if (existingcartItem) {
				state.value = state.value.map((cartItem) =>
					cartItem.id === action.payload.id
						? { ...cartItem, quantity: cartItem.quantity + 1 }
						: cartItem
				);
			} else {
				if(state.value.length === 0) 
					state.id = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
					state.value = [...state.value, { ...action.payload, quantity: 1 }];
			}
		},
		decrease_cart: (state, action) => {
			const existingcartItem = state.value.find(
				(cartItem) => cartItem.id === action.payload.id
			);
			if (existingcartItem) {
				if (existingcartItem.quantity - 1 >= 1) {
					state.value = state.value.map((cartItem) =>
						cartItem.id === action.payload.id
							? { ...cartItem, quantity: cartItem.quantity - 1 }
							: cartItem
					);
				} else {
					state.value = state.value.filter(
						(cartItem) => cartItem.id !== action.payload.id
					);
					if(state.value.length === 0)
						state.id = null;
				}
			} 
			// else state.value = [...state.value, { ...action.payload, quantity: 1 }];
		},
		remove_by_id(state, action) {
			state.value = state.value.filter(
				(cartItem) => cartItem.id !== action.payload.id
			);
			if (state.value.length === 0) state.id = null;
		},
		empty_cart(state) {
			state.value = [];
			state.id = null;
		},
	},
});

// Action creators are generated for each case reducer function
export const { add_to_cart, decrease_cart, remove_by_id, empty_cart } =
	cartSlice.actions;

export default cartSlice.reducer;
